import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequiredUserActionsStorageDaoService } from './dao/required-user-actions-dao/required-user-actions-storage-dao.service';
import { RequiredUserActionsDaoService } from './dao/required-user-actions-dao.service';
import { RequiredUserActionsLogicService } from './logic/required-user-actions/required-user-actions-logic.service';
import { RequiredUserActionsService } from './logic/required-user-actions.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: RequiredUserActionsService,
      useClass: RequiredUserActionsLogicService,
    },
    {
      provide: RequiredUserActionsDaoService,
      useClass: RequiredUserActionsStorageDaoService,
    },
  ],
})
export class RequiredUserActionsModule {}
